import { useSyncExternalStore } from 'react'
import { parseFpsQuery, type FpsQuery } from '../utils/fpsQuery'

const FPS_QUERY_DISABLED: FpsQuery = { isEnabled: false }

let cachedSearch = ''
let cachedFpsQuery: FpsQuery = FPS_QUERY_DISABLED

function subscribe(onChange: () => void) {
    window.addEventListener('popstate', onChange)
    window.addEventListener('hashchange', onChange)
    return () => {
        window.removeEventListener('popstate', onChange)
        window.removeEventListener('hashchange', onChange)
    }
}

function getSnapshot(): FpsQuery {
    const search = window.location.search
    if (search === cachedSearch) {
        return cachedFpsQuery
    }
    cachedSearch = search
    const next = parseFpsQuery(search)
    cachedFpsQuery = next.isEnabled ? next : FPS_QUERY_DISABLED
    return cachedFpsQuery
}

function getServerSnapshot(): FpsQuery {
    return FPS_QUERY_DISABLED
}

/** Reads `fps` from the current URL and re-renders on navigation. */
export function useFpsQuery(): FpsQuery {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
